import React from 'react';

/**
 * Indicates when an ajax call is being waited on and if so, will show a spinning cog from font-awesome
 *
 * @returns {*}
 * @constructor
 */
const Loader = () => {
	return (
		<div className={'text-center loader'} role="status" aria-label="Loading">
			<i className={'far fa-cog fa-spin'} aria-hidden="true">
			</i>
			<span className="sr-only">Loading...</span>
		</div>
	);
};

export default Loader;
